
import React from 'react';
import { Button } from '@/components/ui/button';
import { Purity } from '@/lib/pricing';
import { formatPurity } from '@/lib/formatPurity';

interface PurityButtonsProps {
  metal: 'gold' | 'silver';
  purities: Purity[];
  selectedPurity: Purity;
  onPurityChange: (purity: Purity) => void;
  disabled?: boolean;
}

export function PurityButtons({ metal, purities, selectedPurity, onPurityChange, disabled }: PurityButtonsProps) {
  if (!purities || purities.length === 0) {
    return <p className="text-sm text-muted-foreground text-center">Nessuna quotazione disponibile per questo metallo.</p>;
  }

  return (
    <div className="flex flex-wrap justify-center gap-2">
      {purities.map((purity) => (
        <Button
          key={purity as string}
          variant={selectedPurity === purity ? 'default' : 'outline'}
          size="sm"
          onClick={() => {
            onPurityChange(purity);
          }}
          disabled={disabled}
          className={`transition-all duration-200 rounded-full px-4 ${
            selectedPurity === purity
              ? metal === 'gold'
                ? 'bg-gold hover:bg-gold/90 text-gold-foreground'
                : 'bg-silver hover:bg-silver/90 text-silver-foreground'
              : 'border-muted-foreground/30 text-muted-foreground'
          }`}
        >
          {formatPurity(metal, String(purity))}
        </Button>
      ))}
    </div>
  );
}
